__turbopack_context__.v({
  "breadcrumb": "breadcrumb-module-scss-module__q2RMCG__breadcrumb",
  "general-container": "breadcrumb-module-scss-module__q2RMCG__general-container",
  "partner-logo": "breadcrumb-module-scss-module__q2RMCG__partner-logo",
});
